import './index.scss';

import { Spin } from 'antd';
import cx from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';

import SessionNote from '../../dashboard-routes/SmartSearch/SessionNote';
import Searchbar from './Searchbar';
import SessionCalendar from './SessionCalendar';
import CalendarModal from './CalendarModal';
import store from './store';

@observer
class AddEditMySession extends React.Component {
  componentDidMount() {
    store.fetchCalendarList();
  }

  componentWillUnmount() {
    store.clearStore();
  }

  render() {
    const {
      loading,
      open,
      loadingClients,
      loadingClinics,
      loadingSpecialists,
    } = store;
    const isFirstLoading =
      loading && loadingClients && loadingClinics && loadingSpecialists;

    return (
      <div
        className={cx('AddEditMySession', {
          'Table-loading': isFirstLoading,
        })}
      >
        {isFirstLoading ? (
          <Spin />
        ) : (
          <React.Fragment>
            <Searchbar />
            <div style={{ marginBottom: '10px' }}>
              <SessionNote />
            </div>
            <SessionCalendar />
          </React.Fragment>
        )}
        {open && <CalendarModal />}
      </div>
    );
  }
}

export default AddEditMySession;
